@let result = analysis.result();

<div class="wrapper" [style.--radius]="radius()">
  @if (name() && result?.summary?.type === 'GSA_REGULATION') {
    <div class="name">
      <!--      {{name()}}-->
    </div>
  }
  @if (analysis.type() !== 'GSA_REGULATION') {
    <div class="point-wrapper top" [class.vertical]="!floating()">
      <div class="point" [innerHTML]="analysis.palette().domainRange[1]  | number: '1.0-2'"></div>
      @if (floating()) {
        <svg class="pointy"
             [attr.viewBox]="viewBox()"
             [attr.width]="2 * radius() + 'px'"
             [attr.height]="radius()+ 'px'">
          <path stroke="var(--primary)" stroke-width="var(--border)" [attr.d]="d()"></path>
        </svg>
      }
    </div>
  }
  <!-- Actual content -->
  <div class="container" [class.gsa]="analysis.type() === 'GSA_REGULATION'" [class.floating]="floating()">

    <div (click)="selectingPalette = !selectingPalette">
      <ng-container *ngTemplateOutlet="display; context: {$implicit: analysis.palette(), displayLabels: true}"/>
    </div>
    @if (selectingPalette) {
      <div class="palette-selector" [@selectAnim]>
        @for (group of analysis.paletteGroups; track group.name) {
          @if (group.valid) {
            @for (pName of group.palettes; track pName) {
              @let palette = analysis.paletteOptions.get(pName)!;
              @if (palette !== analysis.palette()) {
                <div (click)="selectPalette(pName)">
                  <ng-container *ngTemplateOutlet="display; context: {$implicit: palette, displayLabels: false}"/>
                </div>
              }
            }
          }
        }
      </div>
    }
  </div>

  @if (analysis.type() !== 'GSA_REGULATION') {
    <div class="point-wrapper bottom" [class.vertical]="!floating()">
      <div class="point" [innerHTML]="analysis.palette().domainRange[0] | number: '1.0-2'"></div>
      @if (floating()) {
        <svg class="pointy"
             [attr.viewBox]="viewBox()"
             [attr.width]="2 * radius() + 'px'"
             [attr.height]="radius() + 'px'">
          <path fill="white" stroke="var(--primary)" stroke-width="var(--border)" [attr.d]="d()"></path>
        </svg>
      }
    </div>
  }
</div>

<ng-template #display let-palette let-displayLabels="displayLabels">
  <div class="palette" [style.background]="palette.verticalGradient">

    @if (displayLabels) {
      @if (result?.summary?.type === 'GSA_REGULATION') {
        <span class="even" matTooltip="Significantly down regulated">
          <mat-icon fontSet="symbols" data-icon="keyboard_double_arrow_down"/>
        </span>
        <span class="even" matTooltip="Non-significantly down regulated">
          <mat-icon fontSet="symbols" data-icon="keyboard_arrow_down"/>
        </span>
        <span class="even" matTooltip="No regulation">
          <mat-icon fontSet="symbols" data-icon="remove"/>
        </span>
        <span class="even" matTooltip="Non-significantly up regulated">
          <mat-icon fontSet="symbols" data-icon="keyboard_arrow_up"/>
        </span>
        <span class="even" matTooltip="Significantly up regulated">
          <mat-icon fontSet="symbols" data-icon="keyboard_double_arrow_up"/>
        </span>
      } @else if (name()) {
        <span class="even">
        <span class="name" [attr.data-value]="name()">{{ name() }}</span>
      </span>
      }
    }

  </div>
</ng-template>

